import { MarketplaceBuildingPriceDto } from "../../../../../../networking/data/responses/marketplace/MarketplaceBuildingPriceDto";
import { MarketplaceNewsItemDto } from "../../../../../../networking/data/responses/marketplace/news/MarketplaceNewsItemDto";
import { MarketplaceNewsType } from "../../../../../../networking/data/responses/marketplace/news/MarketplaceNewsType";
import { MarketplaceBuildingPrice } from "../map/MarketplaceBuildingPrice";

export class MarketplaceNewsItem {
    public readonly address: string;
    public readonly zipCode: string;
    public readonly type: MarketplaceNewsType;
    public readonly price: MarketplaceBuildingPrice;

    public constructor(mpNewsItemDto: MarketplaceNewsItemDto) {
        if (mpNewsItemDto == undefined) {
            throw new Error("Failed to create MarketplaceNewsItem without MarketplaceNewsItemDto.");
        }
        if (mpNewsItemDto.address == undefined || mpNewsItemDto.address.length == 0) {
            throw new Error("Failed to create MarketplaceNewsItem without address.");
        }
        if (mpNewsItemDto.zipCode == undefined || mpNewsItemDto.zipCode.length == 0) {
            throw new Error("Failed to create MarketplaceNewsItem without zipCode.");
        }
        if (mpNewsItemDto.type == undefined) {
            throw new Error("Failed to create MarketplaceNewsItem without type.");
        }
        if (mpNewsItemDto.price == undefined) {
            throw new Error("Failed to create MarketplaceNewsItem without price.");
        }
        this.address = mpNewsItemDto.address;
        this.zipCode = mpNewsItemDto.zipCode;
        this.type = mpNewsItemDto.type;
        this.price = new MarketplaceBuildingPrice(mpNewsItemDto.price);
    }
}